import { omit } from "ramda";
import { Flex, Header2 } from "@base-ui";
import { headerHeight, MeasuresSearch, ExternalNavButton } from "./header.styles";
import HeaderNav from "./HeaderNav";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Header(_ref) {
  var adminAccess = _ref.adminAccess,
    searchOptions = _ref.searchOptions,
    searchQuery = _ref.searchQuery,
    setSearchQuery = _ref.setSearchQuery,
    measuresCategories = _ref.measuresCategories,
    reportCategories = _ref.reportCategories;
  return /*#__PURE__*/_jsx(Flex.Column, {
    bg: "P1",
    className: "nav-header",
    children: /*#__PURE__*/_jsxs(Flex.Row, {
      as: "header",
      height: headerHeight,
      justifyContent: "space-between",
      pr: "4rem",
      children: [/*#__PURE__*/_jsxs(Flex.Row, {
        children: [/*#__PURE__*/_jsx(Header2, {
          className: "hidden-styles",
          id: "site-menu-header",
          children: "V\xE5rden i siffror, huvudmeny"
        }), /*#__PURE__*/_jsx(ExternalNavButton, {
          href: "/",
          mr: "sm",
          children: "V\xC5RDEN I SIFFROR"
        }), /*#__PURE__*/_jsx(HeaderNav, {
          measuresCategories: measuresCategories,
          reportCategories: reportCategories,
          adminAccess: adminAccess
        })]
      }), /*#__PURE__*/_jsx(MeasuresSearch, {
        id: "search-measures-on-site",
        label: "S\xF6k efter indikatorer i systemet",
        hideLabel: true,
        options: searchOptions,
        searchString: (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.q) || "",
        search: function search(q) {
          return (q === null || q === void 0 ? void 0 : q.length) > 0 ? setSearchQuery({
            q: q
          }) : setSearchQuery(omit(["q"]));
        },
        placeholder: "S\xF6k efter indikatorer..."
      })]
    })
  });
}